import type { Metadata } from "next";
import { ThankYouContent } from "@/components/thank-you-content";

export const metadata: Metadata = {
  title: "Thank you",
  description: "Your message has been received by the Quto AI team.",
  // Completion page — not for indexing, and not in the sitemap.
  robots: { index: false, follow: true },
};

export default function ThankYouPage() {
  return <ThankYouContent />;
}
